import axios from 'axios';

export default axios.create({
  baseURL: 'https://b95088z02k.execute-api.us-east-1.amazonaws.com/dev',
  //baseURL: 'https://0f9gboxjed.execute-api.us-east-1.amazonaws.com/dev',
});
